// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-O":"O_power-ocean-home-O__MiWmX"};